export const BRAND_COLOR = {
  Primary: "primary",
  White: "white",
  Black: "black",
  Green: "green",
  Blue: "blue",
} as const;
